import React from 'react'

export const Card = ({ children, className }) => {
  return (
    <section className={`bg-[#CBDFF7] rounded-[40px] ${className}`}>{children}</section>
  )
}